import { NativeDateAdapter } from '@angular/material/core';
import { Constants } from '../../common';

export class CustomDateAdapter extends NativeDateAdapter {
    override format(date: Date, displayFormat: string): string {
        if (displayFormat === Constants.DATE_FORMAT) {
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return date.toDateString();
    }
}
